(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xpa-all-sports-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.XPACountdownController) {
      window.XPACountdownController.init(document);
      return;
    }

    const selector = '[data-xpa-countdown]';
    const timers = new Map();

    const stop = (timer) => {
      const intervalId = timers.get(timer);
      if (intervalId) window.clearInterval(intervalId);
      timers.delete(timer);
    };

    const start = (timer) => {
      if (timers.has(timer)) return;

      const deadline = Number(timer.dataset.deadline);
      const value = timer.querySelector('[data-xpa-countdown-value]');
      const promo = timer.closest('.xpa-promo');
      const status = promo ? promo.nextElementSibling : null;

      if (!Number.isFinite(deadline) || !value || !promo) return;

      const update = () => {
        const remainingMilliseconds = deadline - Date.now();

        if (remainingMilliseconds <= 0) {
          const expiredLabel = timer.dataset.expiredLabel || '';
          value.textContent = expiredLabel;
          if (status && status.matches('[data-xpa-countdown-status]')) status.textContent = expiredLabel;
          promo.hidden = true;
          stop(timer);
          return;
        }

        const totalSeconds = Math.ceil(remainingMilliseconds / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (number) => String(number).padStart(2, '0');

        value.textContent = days + 'D ' + pad(hours) + 'H ' + pad(minutes) + 'M ' + pad(seconds) + 'S';
      };

      const intervalId = window.setInterval(update, 1000);
      timers.set(timer, intervalId);
      update();
    };

    const collect = (scope) => {
      const elements = [];
      if (scope.matches && scope.matches(selector)) elements.push(scope);
      if (scope.querySelectorAll) elements.push(...scope.querySelectorAll(selector));
      return elements;
    };

    const controller = {
      init(scope = document) {
        collect(scope).forEach(start);
      },
      destroy(scope) {
        collect(scope).forEach(stop);
      }
    };

    window.XPACountdownController = controller;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => controller.init(document), { once: true });
    } else {
      controller.init(document);
    }

    document.addEventListener('shopify:section:load', (event) => controller.init(event.target));
    document.addEventListener('shopify:section:unload', (event) => controller.destroy(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
